<template>
    <div style="width: 100%;" class="mymain">
        <v-row justify="center">
            <v-col lg="7" mb="6" sm="12">
                <Tabs />
                <v-card elevation="3" v-if="Object.keys(list).length != 0">
                    <v-card-text class="request-data card-text-custom pt-4">
                        <v-form class="form" ref="profileForm">
                                <div v-for="(item, headerKey) in list.header" :key="headerKey">
                                    <v-text-field 
                                        v-if="item.type == 'text' || item.type == 'number' || item.type == 'email'" 
                                        v-model="name" 
                                        :label="item.name"
                                        :type="item.type"
                                        :rules="[v => !item.required || !!v || 'Обязательное поле']" 
                                        :disabled="!item.can_change">
                                    </v-text-field>
                                    <v-menu v-else-if="item.type == 'date'" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="picker" :label="item.name" readonly prepend-icon="mdi-calendar" :rules="[v => !item.required || !!v || 'Обязательное поле']" :disabled="!item.can_change" required v-bind="attrs" v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker locale="ru-RU" v-model="picker"></v-date-picker>
                                    </v-menu>  

                                    <div v-else-if="item.type == 'base64'">
                                        <label>{{item.name}}</label>

                                        <v-img max-width="100%" class="m-auto" width="150px" :src="item.name" aspect-ratio="1.5" />
                                        <template v-if="item.can_change">
                                            <div class="pt-2 blue--text text-decoration-underline" style="cursor: pointer;">
                                            </div>
                                            <v-file-input v-model="file" :label="item.name" accept="image/*" :rules="[v => !item.required || !!v || 'Обязательное поле', v => !v || v.size < 10000000 || 'Размер файла не должен превышать 10 Мб']" required>
                                            </v-file-input>
                                        </template>
                                    </div>



                                    <template v-else-if="item.type == 'tag'">
									<template>
									<v-autocomplete
										:items="lang[item.tag_name]"
                                        :label="item.name"
										item-text="name"
                                        v-model="language"
                                        :item-value="item.tag_id"
                                        :key="lang[item.tag_name] + updateCount"
                                        multiple
                                        :disabled="!item.can_change"
										:rules="[v => !item.required || Object.keys(v).length != 0 || 'Обязательное поле']">
									</v-autocomplete>
									</template>
									</template>
                                    
            


                            <template v-else-if="item.type == 'reference'">
								<template>
								<v-select
                                :items="reference[item.reference_name]" 
                                item-text="name"
                                v-model="ref"
                                :item-value="item.reference_id" 
                                :label="item.name"
                                :disabled="!item.can_change"
                                :key="reference[item.reference_name] + updateCount"
                                :rules="[v => !item.required || Object.keys(v).length != 0 || 'Обязательное поле']">
								>
										</v-select>
									</template>
								</template>
                            </div>
                            <!-- <v-col lg="12" v-for="(item, itemKey) in list.header" :key="itemKey">

                                <v-text-field v-if="item.type == 'text' || item.type == 'number' || item.type == 'email'" v-model="item.name" :label="item.name" :type="item.type" :rules="[v => !item.required || !!v || 'Обязательное поле']" :disabled="!item.can_change">
                                </v-text-field>

                                <v-menu v-else-if="item.type == 'date'" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="item.name" :label="item.name" readonly prepend-icon="mdi-calendar" :rules="[v => !item.required || !!v || 'Обязательное поле']" :disabled="!item.can_change" required v-bind="attrs" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker locale="ru-RU" v-model="item.value"></v-date-picker>
                                </v-menu>   

                                <div v-else-if="item.type == 'base64'">
                                    <label>{{item.name}}</label>

                                    <v-img max-width="100%" class="m-auto" width="150px" :src="item.value" aspect-ratio="1.5" />
                                    <template v-if="item.can_change">
                                        <div class="pt-2 blue--text text-decoration-underline" style="cursor: pointer;" @click.stop="item.value = null">
                                        </div>
                                        <v-file-input :label="item.name" accept="image/*" :rules="[v => !item.required || !!v || 'Обязательное поле', v => !v || v.size < 10000000 || 'Размер файла не должен превышать 10 Мб']" required>
                                        </v-file-input>
                                    </template>
                                </div>

                                <v-select
                                    v-else-if="item.type == 'tag'"
                                    :items="item.name"
                                    :label="item.name"
                                    multiple
                                    >
                                    <template v-slot:selection="{ item, index }">
                                        <v-chip v-if="index === 0">
                                        <span>{{ item }}</span>
                                        </v-chip>
                                        <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                        >
                                        (+{{ value.length - 1 }} others)
                                        </span>
                                    </template>
                                </v-select>

                                <v-select 
                                v-else-if="item.type == 'reference'"
                                :items="'dasdsadasddsaads'" 
                                :label="item.name" 
                                :rules="[v => !item.required || Object.keys(v).length != 0 || 'Обязательное поле']">
                                </v-select>                        


                            </v-col> -->
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>



<script>
import axios from 'axios'
import Tabs from '../components/app/Tabs.vue'

export default {
    data() {
    return {
        form: {
            name: null,
            language: null,
            ref: null,
            date: null,
            file: null,
        },
   /* date: {
        mondayFirst: true,
        format: 'dd.MM.yyyy',
        value: date
      },*/

      list: {},
      data: {},
      reference: {},
      lang: {},
      menu: false,
      modal: false,
      menu2: false,
      updateCount: 0,
      picker: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    }
    },
    mounted() {
        this.form = Object.assign(this.form)
        this.getprofile()
    },
    methods: {
       async getprofile() {
        await axios.get('https://api.portfolio.edus.kz/v1/ru/detail/education', {
            }).then((response) => {
                this.list = response.data
                console.log(this.list)
                this.setEditMode();
                this.lanG()
             })
             .catch(err => { 
                console.log(err)
            })
        },


        async setEditMode() {
				for(let key in this.list.header) {
					let item = this.list.header[key];
					if(item.type == 'reference' && item.can_change && !this.reference[item.reference_name]) {
					await axios.get('https://api.portfolio.edus.kz/v1/ru/reference/'+item.reference_name).then((response) => {
							this.reference[item.reference_name] = response.data;
                            this.updateCount++
                            console.log(this.reference)
						}).catch(err => {
                            console.log(err)
                        });
					}
				}
        },
              async lanG() {
				for(let key in this.list.header) {
					let item = this.list.header[key];
					if(item.type == 'tag') {
					await axios.get('https://api.portfolio.edus.kz/v1/ru/reference/'+item.tag_name).then((response) => {
						this.lang[item.tag_name] = response.data;
                        this.updateCount++
                        console.log(this.lang)
						}).catch(err => {
                            console.log(err)
                        });
					}
				}
        }
    },
    components: {
        Tabs,
},
}
</script>